import Translations from '../components/pages/Translations/Translations'

export default [
  {
    path: '/',
    redirect: { name: 'translations' }
  },
  {
    path: '/translations',
    redirect: { name: 'translations' }
  },
  {
    path: '/translations/list',
    name: 'translations',
    component: Translations,
    meta: {
      waitForSlots: ['filters', 'tableHead']
    }
  }
]
